import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PremiumDetails from "../components/TenantAccount/PremiumDetails";
import theme from "../styles/styleTheme";
import { useUserAuth } from "../context/UserAuthContext";
import { usePayment } from "../hooks/payment/usePayment";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const PremiumUpgrade = () => {
  const { t } = useTranslation();
  const { user } = useUserAuth();
  const { createPayment } = usePayment();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const checkout = () => {
    createPayment(user?.id);
  };
  useEffect(() => {
    document.title = `${t("profile.upgrade")} - GoHome.rent`;
  }, []);

  return (
    <Container maxWidth={"xl"}>
      <Grid container padding={3} spacing={3}>
        <Grid item xs={12}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={1}
            width={"100%"}
          >
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <IconButton
                size="small"
                sx={{
                  transition: "none",
                  backgroundColor: theme.palette.primary.main,
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.main,
                  },
                }}
                onClick={() => navigate(-1)}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography fontWeight={400} variant="h2">
                Premium account
              </Typography>
            </Box>
            <Chip
              icon={<AutoAwesomeIcon color="primary" fontSize="small" />}
              label={t("profile.most_chosen")}
              variant="outlined"
              sx={{
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                fontWeight: 600,
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <PremiumDetails label={false} />
          <Box
            marginTop={4}
            display={"flex"}
            width={"100%"}
            justifyContent={isSmallScreen ? "center" : "flex-start"}
          >
            <Button
              startIcon={<AutoAwesomeIcon />}
              disableElevation={true}
              size={isSmallScreen ? "small" : "large"}
              variant="contained"
              onClick={checkout}
              color="primary"
            >
              {t("profile.upgrade_button")}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PremiumUpgrade;
